<div class="card card-accent-primary">
  @if (listHeader) {
    <div class="card-header d-flex align-items-center">
      <ng-template
        [ngTemplateOutlet]="listHeader.tpl"
        [ngTemplateOutletContext]="{}"></ng-template>
    </div>
  }
  @if (filter) {
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <div class="row justify-content-start w-100">
          <search-filter
            class="col-md-12"
            [transactionFilter]="transactionFilter"
            [ngClass]="
              extraBar
                ? 'col-lg-7 col-md-6'
                : dateType
                  ? 'col-lg-10'
                  : 'col-lg-12'
            "
            [options]="filter"
            [total]="total"
            [showFilterSearchField]="false"
            (filterChange)="onFilterChange($event)"
            [visibleItems]="listVisible"
            [isSelectable]="selectable"
            [checked]="checked"></search-filter>
          @if (dateType) {
            <date-filter
              class="col-sm-12"
              [ngClass]="extraBar ? 'col-lg-3 col-md-3' : 'col-md-2'"
              [type]="dateType"
              (rangeChange)="onDateChange($event)"></date-filter>
          }
          @if (extraBar) {
            <div class="col-lg-2 col-md-3 col-sm-12 mt-2">
              <ng-template
                [ngTemplateOutlet]="extraBar.tpl"
                [ngTemplateOutletContext]="{}"></ng-template>
            </div>
          }
        </div>
        <div
          class="btn-group float-right btn-group justify-content-end align-items-start mt-2"
          role="group"
          aria-label="Basic example">
          @if (selectable === true) {
            <button
              type="button"
              class="btn-transparent text-dark"
              (click)="toggleChecked()"
              (keydown.enter)="toggleChecked()">
              <i class="fa-regular" [ngClass]="getCheckState()"></i>
            </button>
          }
          @if (actions && actions.length > 0) {
            <div dropdown class="dropdown">
              <button
                dropdownToggle
                type="button"
                class="btn-transparent dropdown-toggle align-middle text-dark"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="icon icon-options-vertical"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                @for (action of actions; track action) {
                  <button
                    class="dropdown-item"
                    [id]="action.name"
                    type="button"
                    (click)="action.action()"
                    (keydown.enter)="action.action()"
                    [disabled]="action.disabled && action.disabled()">
                    @if (action.icon) {
                      <i [class]="action.icon"></i>
                    }
                    {{ action.name }}
                  </button>
                }
                @if (allItems) {
                  <app-table-export
                    (prepareData)="prepareCSVData()"
                    [tableData]="allItems"
                    fileName="exported_data"></app-table-export>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  <div class="list-group list-group-flush position-relative">
    @if (headerLabels) {
      <div
        class="list-group-item fw-bold py-2 header-labels"
        data-cy="list-header-labels">
        <div class="list-group-item-header d-flex align-items-center">
          <ng-template
            [ngTemplateOutlet]="itemHeaderLabel.tpl"
            [ngTemplateOutletContext]="{
              $implicit: label,
              item: label,
            }"></ng-template>
        </div>
      </div>
    }

    @if ((loading | async) || (items | async)?.length != 0) {
      <div
        class="scroll-list"
        infiniteScroll
        [infiniteScrollDistance]="1"
        (scrolled)="onScroll()"
        [scrollWindow]="false">
        @for (item of items | async; track item; let idx = $index) {
          <div
            class="list-group-item"
            [attr.data-cy]="'list-item-' + idx"
            [class.list-group-item-action]="onClick.observers.length != 0"
            [ngClass]="itemClasses(item)"
            (click)="onRowClick(item, $event)"
            (keydown.enter)="onRowClick(item, $event)"
            (contextmenu)="onRowRightClick(item, $event)">
            <div class="list-group-item-header d-flex align-items-center">
              @if (itemExpand && expandable(item)) {
                <button
                  type="button"
                  class="btn btn-transparent expansion-btn text-dark p-1"
                  [attr.data-cy]="'item-' + idx"
                  (click)="onItemSelected(item, $event)"
                  (keydown.enter)="onItemSelected(item, $event)">
                  <i
                    class="fa fa-lg text-dark"
                    [ngClass]="
                      show.get(item) ? 'fa-angle-down' : 'fa-angle-right'
                    "></i>
                </button>
              }
              @if (selectable) {
                <div class="col-auto">
                  <div class="me-3">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      (click)="
                        $event.shiftKey
                          ? multipleToggle(idx, $event)
                          : setNotSelectItem($event)
                      "
                      (keydown.enter)="
                        $event.shiftKey
                          ? multipleToggle(idx, $event)
                          : setNotSelectItem($event)
                      "
                      (change)="itemChecked(item, idx, $event)"
                      [checked]="fillCheckedItems(item)" />
                  </div>
                </div>
              }
              <ng-template
                [ngTemplateOutlet]="itemHeader.tpl"
                [ngTemplateOutletContext]="{
                  $implicit: item,
                  item: item,
                }"></ng-template>
              @if (itemActions && itemActions.length > 0) {
                <div class="col-auto justify-content-end d-flex">
                  <div class="btn-group">
                    @for (action of itemActions; track action) {
                      <button
                        type="button"
                        (click)="action.action(item)"
                        (keydown.enter)="action.action(item)"
                        class="btn btn-transparent text-dark p-1">
                        <i class="fa fa-lg" [ngClass]="action.icon"></i>
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
            @if (show.get(item)) {
              <div class="expand-tab" [attr.data-cy]="'expand-item-' + idx">
                <ng-template
                  [ngTemplateOutlet]="itemExpand.tpl"
                  [ngTemplateOutletContext]="{item: item}"></ng-template>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="alert alert-warning row g-0">
        <div class="col">
          {{
            noItemsMessage?.length
              ? noItemsMessage
              : 'No results returned for given filter.'
          }}
        </div>
      </div>
    }
    @if (loading | async) {
      <loader-line></loader-line>
    }
  </div>
</div>
